/* eslint-disable camelcase */
import * as React from "react";
import { generatePath, useHistory, useParams } from "react-router";
import { DeviceId } from "../api-clients/_api";
import { useBee } from "../hooks/useBee";

export const deviceBasePath = "/:deviceId";

export type RoutePathsParams = {
	deviceId?: DeviceId;
};

export interface IRoutePathsContext {
	push: <S>(path: string, params?: any, state?: S) => void;

	replace: <S>(path: string, params?: any, state?: S) => void;
}

export const RoutePathsContext = React.createContext<IRoutePathsContext>(undefined);

export const RoutePathsProvider = ({ children }: React.PropsWithChildren<unknown>) => {
	const history = useHistory();
	const { findBee } = useBee();
	const { deviceId } = useParams<RoutePathsParams>();

	React.useEffect(() => {
		if (deviceId) {
			findBee({ deviceId });
		}
	}, []);

	const push = React.useCallback(
		(path, params, state) => history.push(generatePath(path, { deviceId, ...params }), state),
		[deviceId],
	);

	const replace = React.useCallback(
		(path, params, state) => history.replace(generatePath(path, { deviceId, ...params }), state),
		[deviceId],
	);

	return (
		<RoutePathsContext.Provider
			value={{
				push,
				replace,
			}}
		>
			{children}
		</RoutePathsContext.Provider>
	);
};

export const useRoutePaths = () => React.useContext(RoutePathsContext);
